import {
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Spacer,
  Stack,
} from '@chakra-ui/react';
import ErrorMessage from '@components/ErrorMessage';
import FormControl from '@components/FormControl';
import MyImage from '@components/MyImage';
import { configEnv } from '@libraries/config';
import Link from 'next/link';
import { memo } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { FiMail } from 'react-icons/fi';
import { useAction } from '../Login.action';

const Form: React.FC = (): JSX.Element => {
  const { formik, isShowPassword, onShowPassword, isLoading } = useAction();

  const handleKeyDown = (e) => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };

  const handleInput = (e) => {
    const value = e.target.value.replace(/\s/g, '');
    formik.setFieldValue('password', value);
  };

  return (
    <Box minW="450px">
      <HStack justify="center">
        <MyImage
          src={`${configEnv.assetUrl}/logo.png`}
          alt={configEnv.appName}
          w="200px"
          h="48px"
          objectFit="contain"
        />
      </HStack>
      <Heading mt="8" size="lg">
        Selamat datang
      </Heading>
      <Spacer h="10" />
      <form onSubmit={formik.handleSubmit}>
        <Stack spacing={4}>
          <FormControl
            id="email"
            label="Email"
            isInvalid={Boolean(formik.errors.email)}
          >
            <InputGroup size="lg">
              <Input
                pr="3rem"
                placeholder="Masukan email"
                name="email"
                onChange={formik.handleChange}
                value={formik.values?.email}
              />
              <InputRightElement width="3rem">
                <FiMail />
              </InputRightElement>
            </InputGroup>
            <ErrorMessage message={formik.errors.email} />
          </FormControl>
          <FormControl
            id="password"
            label="Password"
            isInvalid={Boolean(formik.errors.password)}
          >
            <InputGroup size="lg">
              <Input
                pr="3rem"
                placeholder="Masukan password"
                type={isShowPassword ? 'text' : 'password'}
                name="password"
                value={formik.values?.password}
                onKeyDown={handleKeyDown}
                onChange={handleInput}
              />
              <InputRightElement
                width="3rem"
                onClick={onShowPassword}
                cursor="pointer"
              >
                {isShowPassword ? <FaEye /> : <FaEyeSlash />}
              </InputRightElement>
            </InputGroup>
            <ErrorMessage message={String(formik.errors?.password)} />
          </FormControl>
        </Stack>
        <Spacer h="6" />
        <Flex justify="flex-end">
          <Link href="/forgot-password" passHref>
            <Button variant="link">Lupa kata sandi?</Button>
          </Link>
        </Flex>
        <Spacer h="8" />
        <Button
          size="xl"
          w="full"
          color={'white'}
          isLoading={isLoading}
          isDisabled={!(formik.isValid && formik.dirty) || isLoading}
          type="submit"
        >
          Masuk
        </Button>
      </form>
    </Box>
  );
};

export default memo(Form);
